import type { ReactNode } from "react";
import { parseTitleEmphasis } from "@/utils/blog/title";

/**
 * Render a post title with its `*accent*` span as the Playfair-italic brand
 * accent (`<i>` inherits Playfair + brand color from blog.css). No asterisks →
 * the plain title.
 */
export function renderTitleEmphasis(title: string): ReactNode {
  const { before, accent, after } = parseTitleEmphasis(title);
  if (accent === null) return title;
  return (
    <>
      {before}
      <i>{accent}</i>
      {after}
    </>
  );
}
